///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthAbortOperationCommand extends GtthAbstractCommand {
    commandNameToTerminate: string;

    getCommandName(): string {
        return 'GtthAbortOperationCommand';
    }

    create(commandNameToTerminate: string): this {
        this.commandNameToTerminate = commandNameToTerminate;
        return this;
    }

    protected doCommand(): void {
        const abortOperationActivity = this.createActivityDTO(false);
        abortOperationActivity.commandNameToTerminate = this.commandNameToTerminate;
        this.sendActivity(abortOperationActivity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
            this.commandResolve(false);
        } else {
            this.commandResolve(true);
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
